var render = function render(){var _vm=this,_c=_vm._self._c;return (!!this.articles && !!this.articles.length)?_c('section',{staticClass:"px-5 xl:px-8 grid xl:grid-cols-3 gap-6 mt-6 tt-bg-light"},_vm._l((_vm.articles),function(article,index){return _c('ArticleCard',{key:'article' + index,attrs:{"hh":"h-60","article":article,"homepage":true}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }